module.exports = __webpack_public_path__ + "img/btc.2c5400ce.svg";